import { memo } from 'react';

import { toDate, YearMonthDayString } from 'bloko/blocks/calendar/datesHelper';
import Text from 'bloko/blocks/text';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import formatDate from 'Modules/formatDate';
import translation from 'src/components/translation';
import { PriceCartProductType } from 'src/models/price/priceCart';
import { TariffProductType, START_AFTER_PAYMENT, StartAfterPayment } from 'src/models/price/product.types';

const TrlKeys = {
    startAfterPayment: 'price.cart.tariffField.activationDate.startAfterPayment',
    date: 'price.cart.tariffField.activationDate.date',
};

const ActivationDate: TranslatedComponent<{ product: PriceCartProductType<TariffProductType> }> = ({
    trls,
    product,
}) => {
    const activationDate: YearMonthDayString | StartAfterPayment | undefined = product.activationDate;
    if (activationDate === undefined) {
        return null;
    }
    if (activationDate === START_AFTER_PAYMENT) {
        return <Text>{trls[TrlKeys.startAfterPayment]}</Text>;
    }
    const date = toDate(activationDate);
    const renderedDate = formatDate(date, 'd MMMM yyyy');
    return (
        <Text>
            {formatToReactComponent(trls[TrlKeys.date], {
                '{0}': <span suppressHydrationWarning>{renderedDate}</span>,
            })}
        </Text>
    );
};

export default memo(translation(ActivationDate));
